import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {ICollectionPathObject} from "../../collectionDiscovery.service";
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";
import {beacon, PrimolyticsService} from "../../../analytics/primolytics.service";

const get = require('lodash/get');

@Component({
    selector: 'prm-collection-navigation-breadcrumbs-item',
    templateUrl: 'components/collectionDiscovery/collectionNavigationBreadcrumbs/collectionNavigationBreadcrumbsItem/collection-navigation-breadcrumbs-item.html',
})

export class PrmCollectionNavigationBreadcrumbsItem implements OnInit {
    @Input() pathObject: ICollectionPathObject;
    @Input() isRootObject: boolean;
    @Input() institution: string;
    @Input() parentTab: string;
    @Input() isAlmaDisplay: Boolean;
    @Input() isLast: Boolean;
    private COLLECTION_DISCOVERY_STATE = STATE_NAMES.COLLECTION_DISCOVERY;
    private _title: string;
    private _breadcrumbStateParams: {} | { collectionId: string };

    constructor(@Inject('collectionDiscoveryIcons') private collectionDiscoveryIcons: Object,
                private primolyticsService: PrimolyticsService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$translate') private $translate) {
    }

    ngOnInit() {
	    this.$translate('nui.colldiscovery.lobby.toptitle').then((translation)=>{
            this._title= this.isRootObject? translation  : this.pathObject.name;
        });

        this._breadcrumbStateParams = this.isRootObject ? {collectionId: undefined} : {collectionId: this.pathObject.pid};
        this._breadcrumbStateParams['vid'] = this.$stateParams.vid;
        if (this.institution) {
            this._breadcrumbStateParams['inst'] = this.institution;
        }
    }

    @beacon({'p': 'brief', 'op': 'linktoPath'})
    private sendLinktoPathBeacon(item?) {
    }
    
    @beacon({'p': 'moreFromTheSame', 'op': 'clickToCollection'})
    private sendClickToCollectionBeacon() {
    }
    
    private runCollectionDiscoveryBeacon() {
        if (this.parentTab === 'brief') {
            this.sendLinktoPathBeacon(this.pathObject);
        } else if (this.parentTab === 'moreFromTheSame') {
            this.sendClickToCollectionBeacon();
        }
    }

    get title(){
        return this._title
    }

    get breadcrumbStateParams() {
        this._breadcrumbStateParams['query'] = null;
        if(this.isRootObject){
            this._breadcrumbStateParams['sortby'] = null;
            this._breadcrumbStateParams['sortItemsBy'] = null;
        }
        return this._breadcrumbStateParams;
    }

	get tooltip() {
        return get(this.pathObject, 'tooltip') || this.title;
    }
    
    public displaySeparator() {
        return (this.parentTab === 'brief');
    }
    
    // specify for Alma viewer only to display collection in a separate tab
    public getTargetName() {
    	return (this.isAlmaDisplay) ? "_blank" : "";
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/collectionDiscovery/collectionNavigationBreadcrumbs/collectionNavigationBreadcrumbsItem/collectionNavigationBreadcrumbsItem.directive.ts